/**
 * Centralized constants and external URLs
 * All application constants and external service URLs should be defined here
 */

/**
 * API Endpoints
 *
 * @deprecated Use API_ENDPOINTS from '../api/endpoints' instead
 * This is kept for backward compatibility
 */
export { API_ENDPOINTS } from '../api/endpoints'

/**
 * External Service URLs
 */
export const EXTERNAL_URLS = {
  OSM_NOMINATIM: 'https://nominatim.openstreetmap.org',
  EMAIL_APP: 'https://mail.google.com',
} as const

/**
 * Default Values
 */
export const DEFAULTS = {
  API_URL: 'http://localhost:8000/api',
  MAPBOX_STYLE_STREET: 'mapbox://styles/mapbox/streets-v12',
  MAPBOX_STYLE_SATELLITE: 'mapbox://styles/mapbox/satellite-streets-v12',
  MAP_CENTER_LNG: -75,
  MAP_CENTER_LAT: 17.5,
  MAP_DEFAULT_ZOOM: 5,
  OSM_USER_AGENT: 'Geographic-Map-Scoring-App',
} as const

/**
 * Public Routes (routes that don't require authentication)
 */
export const PUBLIC_ROUTES = [
  '/login',
  '/forgot-password',
  '/set-password',
  '/check-email',
  '/password-reset-success',
] as const
